import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import useVerificationCode from 'hooks/use-verification-code'
import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import api from 'services/api'

const useComponent = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const { code, inputStates, handleChange, handleKeyDown, handleSetCode, handleClear } =
    useVerificationCode('numberField')

  const { openAlert } = useAlert()
  const { user, updateUserData, signOut } = useAuth()

  const history = useHistory()
  const { theme } = useCustomTheme()

  const resendCode = useCallback(async () => {
    try {
      if (user == null) {
        return
      }

      const payLoad = {
        userId: user.id,
        email: user.email,
      }

      await api.post('/passwords/email-confirmation', payLoad)
      openAlert('Código de Confirmação Reenviado!', 'success')
    } catch (error) {
      const { data } = error as any

      openAlert(data.message, 'error')
    }
  }, [user, openAlert])

  const onSubmit = useCallback(async () => {
    if (code == null || code?.length < 6) {
      return
    }

    try {
      setIsLoading(true)

      if (user == null) {
        return
      }

      const payLoad = {
        userId: user.id,
        email: user.email,
        confirmationCode: code,
      }
      await api.patch('/users/confirm-email', payLoad)
      await updateUserData()

      setIsLoading(false)

      history.push('/redirect')
    } catch (err) {
      setIsLoading(false)
      openAlert('Código de Confirmação Inválido!', 'error')
    }
  }, [history, code, user, updateUserData, openAlert])

  const handleBack = () => {
    signOut()
    history.push('/')
  }

  const handlePaste = (event: ClipboardEvent) => {
    event!.preventDefault()
    let pastedText = event.clipboardData?.getData('text/plain') || ''

    pastedText = pastedText.trim()

    if (pastedText.length == 6) {
      handleClear()
      handleSetCode(Array.from(pastedText, Number))
    }
  }

  useEffect(() => {
    if (user && user.emailIsConfirmed) {
      history.push('/redirect')
    }

    document.addEventListener('paste', handlePaste)
    return () => document.removeEventListener('paste', handlePaste)
  }, [])

  return {
    theme,
    user,
    inputStates,
    isLoading,
    resendCode,
    onSubmit,
    handleKeyDown,
    handleChange,
    handleBack,
  }
}

export default useComponent
